import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { loginRef,baseUrl } from 'src/assets/api/config'

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    // 通过vuex state获取当前的userInfo
    let info = store.state.userInfo
    let uid = 0
    try{
        if(info){
            uid = JSON.parse(info).id
        }
    }catch(e){
        console.log('uid格式有误');
    }
    if(uid) {
        next()
    }else{
        if(location.href.indexOf('buzhi.com') < 0){            
            return;
        }
        window.location.href = loginRef + baseUrl
    }  
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js